import { PriceListProductPropertyItemPerioid } from "./price-list-product-property-item-perioid.model";

export class PriceListProductPropertyItem {
  id: number;
  key: string;
  keyFrom: number;
  keyTo: number;
  productPropertyPerioids: PriceListProductPropertyItemPerioid[];
}
